import {
  ListRepositoriesDocument,
  type ListRepositoriesQuery,
  type ListRepositoriesQueryVariables,
  useListRepositoriesQuery,
  withStandardListHook,
} from '@spotify/confidence-graphql';

type Repository = Extract<
  NonNullable<ListRepositoriesQuery['repositories']>,
  { __typename: 'RepositoriesV1ListRepositoriesResponse' }
>['repositories'][number];

type NoCustomVariables = Record<never, never>;

export const githubIntegrationStarted = (
  installations: ReadonlyArray<unknown> | null | undefined,
): boolean | undefined => {
  if (installations === null || installations === undefined) {
    return undefined;
  }
  return installations.length > 0;
};

export const useRepositories = withStandardListHook<
  ListRepositoriesQuery,
  Repository,
  'repositories',
  NoCustomVariables,
  ListRepositoriesQueryVariables
>(useListRepositoriesQuery, 'repositories', {
  query: ListRepositoriesDocument,
  typename: 'RepositoriesV1ListRepositoriesResponse',
  mapVariables: () => ({}),
});
